import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class TransferenciaService {
    private apiPhp = environment.api;

    private httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    };

    constructor(private http: HttpClient) {}

    public getAluno(): Observable<any> {
        return this.http.get<any>(
            this.apiPhp.concat(`v1/inscricao/transferencia/aluno/mostrar-inscricao`),
        );
    }

    public postInscricao(data: any): Observable<any> {
        const dataEnvio = {
            ano: data.ano,
            alunoId: data.alunoId,
            alunoNome: data.dadosAluno.nome,
            dataNascimento: this.formatarData(data.dadosAluno.dataNascimento),
            dataIngresso: this.formatarData(data.dadosAluno.dataIngresso),
            cpf: data.dadosAluno.cpf,
            racaId: data.dadosAluno.racaEtnia,
            recomendacoesMedicas: data.dadosAluno.recomendacoesMedicas,
            rg: data.dadosAluno.rg,
            orgaoExpeditor: data.dadosAluno.orgaoExpeditor,
            cartaoSus: data.dadosAluno.cartaoSus,
            certidaoNascimento: data.dadosAluno.certidaoNascimento,
            sexo: data.dadosAluno.sexo,
            naturalidade: data.dadosAluno.naturalidade,
            nacionalidade: data.dadosAluno.nacionalidade,
            ufNascimento: data.dadosAluno.ufNascimento,
            pcd: data.dadosAluno.pcd,
            pcdDescricao: data.dadosAluno.pcdDescricao,
            bolsaFamilia: data.dadosAluno.bolsaFamilia,
            transporte: data.dadosAluno.transporte,
            turno: data.dadosAluno.turno,
            autorizacaoImagem: data.dadosAluno.autorizacaoImagem,
            escolaPretendidaId: data.escolaPretendidaId,
            enderecos: (data.enderecos || []).map((endereco: any) => ({
                ...endereco,
                zona: endereco?.zona ?? '',
            })),
            responsaveis: data.responsaveis,
            informacoes: data.informacoes,
            escolaAtualId: data.escolaAtual.escola,
            serieAtualId: data.escolaAtual.serie,
            vacinas: data.vacinas,
        };

        return this.http.post<any>(
            this.apiPhp.concat(`v1/inscricao/transferencia/salvar-inscricao`),
            dataEnvio,
            this.httpOptions,
        );
    }

    private formatarData(dataNascimento: string): string {
        if (!dataNascimento) {
            return '';
        }

        dataNascimento = dataNascimento.replace(/\D/g, '');

        if (dataNascimento.length !== 8) {
            return '';
        }

        let dia = dataNascimento.substring(0, 2);
        let mes = dataNascimento.substring(2, 4);
        let ano = dataNascimento.substring(4, 8);

        let dataFormatada = `${dia}-${mes}-${ano}`;

        return dataFormatada;
    }

    public getTransferencias(inscricaoId: number, escolasMax?: number): Observable<any> {
        return this.http.get<any>(
            this.apiPhp.concat(
                `v1/inscricao/${inscricaoId}/transferencia/possiveis-transferencias${escolasMax ? `/${escolasMax}` : ''}`,
            ),
        );
    }
}
